import './driver_index_app.css';
import Footer from '../common/footer/footer.tsx';
import Banner from './banner/banner.tsx';
import { Outlet } from 'react-router';

function DriverIndexApp() {
    return (
        <>
            <Banner />
            <div className="main_container">
                <Outlet />
            </div>
            <Footer />
        </>
    );
}

export default DriverIndexApp;
